import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { Booking } from './Booking'
import { Requirement } from './Requirement'
import { Resource } from './Resource'
import { FKType } from './SQLBuilder'

export type AllocationConstructorArgs = ConstructorArgs<() => Allocation>

export class Allocation extends BaseRecord {
    readonly recordType = 'allocation'

    constructor(data?: Partial<AllocationConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }
    }

    clone(overrides?: Partial<AllocationConstructorArgs>): Allocation {
        return new Allocation({ ...this.serializeForClone(), ...overrides })
    }

    static initWithResource(resource: Resource, requirement?: Requirement): Allocation {
        const allocation = new Allocation()
        allocation.resource = resource
        allocation.requirement = requirement
        return allocation
    }

    public deserialize(data: any): void {
        super.deserialize(data)

        if (data.booking) this.booking = BaseRecord.fromSerializer(data.booking, Booking)
        if (data.resource) this.resource = BaseRecord.fromSerializer(data.resource, Resource)
        if (data.requirement)
            this.requirement = BaseRecord.fromSerializer(data.requirement, Requirement)
    }

    static fk: FKType = {
        bookings: ['booking'],
        resources: ['resource'],
        requirements: ['requirement'],
    }

    static dataType(): DataType {
        return 'allocations'
    }

    get booking(): Booking | undefined {
        return this.getForeignRecord('booking', Booking)
    }
    set booking(booking: Booking | undefined) {
        this.setForeignRecord('booking', booking)
    }
    get resource(): Resource | undefined {
        return this.getForeignRecord('resource', Resource)
    }
    set resource(resource: Resource | undefined) {
        this.setForeignRecord('resource', resource)
    }
    get requirement(): Requirement | undefined {
        return this.getForeignRecord('requirement', Requirement)
    }
    set requirement(requirement: Requirement | undefined) {
        this.setForeignRecord('requirement', requirement)
    }
}
